<script>
  import axios from "axios";
    import { session } from "./js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  
  export let id = ""; 
  export let note = ""; 
  let toggleclass = false;
  let toggleclassInput = false;
  let text = "";
  let textTrigger = "Tambah catatan untuk penjual";
  $: text = note;
  if (note.length > 0) {
    textTrigger = "Ubah Catatan";
  }
  if (note) {
    text = note;
    toggleclass = "hidden";
  } else {
    toggleclass = "block";
  }
  function show() {
    toggleclassInput = true;
    toggleclass = false;
    textTrigger = "";
  }
  function hide() {
    toggleclassInput = false;
    toggleclass = true;
    if (text.length < 1) {
      textTrigger = "Tambah catatan untuk penjual";
    } else {
      textTrigger = "Ubah Catatan";
    }
  }
  function init(el) {
    el.focus();
  }
  function handleEnter(el) {
    if (el.keyCode === 13){ hide();
    changeNote(id, text)
    }
  }
  $: lengthCount = text.length;

  function changeNote(id, note) {
    axios
      .post(settings.url + "/sipade/cart?authorization=" + settings.token, {
        productID: id,
        note: note,
        updatenote: true,
      })
      .then(function (response) { 
      })
      .catch(function (error) { 
      });
  }
</script>

<div class="text-xs">
  {#if toggleclassInput}
    <div class="w-full text-gray-600 mr-2">
      <label for="catatan" class="text-sm font-light block relative mt-3">
        <input
          maxlength="100"
          type="text"
          class="form-input hover:border-blue-400 border-gray-500
              focus:shadow-none text-sm w-full placeholder-gray-400"
          placeholder="ketik catatan..."
          bind:value={note}
          on:blur={hide}
          on:keyup={handleEnter}
          use:init />
        <span
          class="text-sm font-light block absolute top-0 mx-3 px-1
              -mt-2 bg-white">Catatan
          untuk toko (optional)
          <span
            class="text-right
                text-xs text-gray-500 my-2">{lengthCount}/100</span></span>
        <span
          class="text-red-400 warning text-xs italic border
              border-red-300 rounded-full rounded-tl-none px-2
              mx-auto font-mono hidden" />
      </label>
    </div>
  {/if}
</div>

<div class="mt-2 text-xs flex">
  {#if text}
    {#if toggleclass}
      <div class="w-auto font-light text-gray-600 mr-2">{text}</div>
    {/if}
  {/if}
  <div class="text-green-500 font-semibold mr-2 cursor-pointer" on:click={show}>
    {textTrigger}
  </div>
</div>
